export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.smsAutoApproval = this.resolve.smsAutoApproval;
    }

    submit() {
        this.close({$value: this.smsAutoApproval});
    }

    notModified() {
        return this.smsAutoApproval === this.resolve.smsAutoApproval;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/edit-sms-settings/edit-sms-settings.controller.js